import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { generateTraceparent } from '@zeusm/shared/core/helpers';

/**
 * TraceInterceptor is an HTTP interceptor that adds a `traceparent` header to each outgoing HTTP request.
 * The `traceparent` header is used for distributed tracing and contains a unique trace ID and span ID.
 */
@Injectable()
export class TraceInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const modifiedReq = req.clone({
      setHeaders: { traceparent: generateTraceparent() },
    });

    return next.handle(modifiedReq);
  }
}
